module.exports = __webpack_public_path__ + "img/offer-escalated.5febc3a9.png";